import { state } from './state'
import { RequestGetters, getters } from './getters'
import { Mutations, mutations } from './mutations'
import {
  Store as VuexStore,
  CommitOptions,
  Module,
} from 'vuex';
import type { State } from './state';
import { RootState } from '@/store';
  
export { State };

export type RequestStore<S = State> = Omit<VuexStore<S>, 'getters' | 'commit' | 'dispatch'> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  getters: {
    [K in keyof RequestGetters]: ReturnType<RequestGetters[K]>
  };
};

export const store: Module<State, RootState> = {
  state,
  mutations,
  getters,
};